import { Dialog } from "@mui/material";
import * as React from "react";

import { AddToCollection } from "@/shared/components/collections";
import { RobotoButton } from "@/shared/components/RobotoButton";
import { SessionRecord } from "@/shared/domain/sessions";

interface AddSessionToCollectionProps {
  sessionId: SessionRecord["session_id"];
}

/**
 * Button + dialog that adds a single session to a collection. Mirrors
 * `AddEventToCollection`; the entry point for the `/sessions/:sessionId`
 * detail page.
 */
export function AddSessionToCollection({
  sessionId,
}: AddSessionToCollectionProps) {
  const [open, setOpen] = React.useState(false);

  return (
    <>
      <RobotoButton
        variant="outlined"
        size="small"
        eventName="SessionAddToCollectionClicked"
        eventProperties={{ sessionId }}
        onClick={() => setOpen(true)}
      >
        Add to Collection
      </RobotoButton>
      <Dialog
        open={open}
        onClose={() => setOpen(false)}
        data-not-draggable="true"
      >
        <AddToCollection
          selected={{ type: "Session", items: new Set([sessionId]) }}
          onCancel={() => setOpen(false)}
        />
      </Dialog>
    </>
  );
}
